module.exports = __webpack_public_path__ + "img/beep_04.4dd81c7d.png";